
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  registerUserDataFormHeadline: {
    id: "RegisterUserDataForm.headline",
    defaultMessage: "Please enter your personal data here.",
  },
  registerUserDataFormButton: {
    id: "RegisterUserDataForm.button",
    defaultMessage: "Register now",
  },
  registerUserDataFormLogoutLink: {
    id: "RegisterUserDataForm.logout",
    defaultMessage: "Return to login",
  },
});

export default MESSAGES;